'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageUserAccountStoreService
 * @description Retrieves information from the user account in the Api (not set), based
 * on {@link vTvPackageServices.TvPackageCartStoreInterface TvPackageCartStoreInterface}
 */

angular.module('v-tv-package-services').factory('TvPackageUserAccountStoreService', function TvPackageUserAccountStoreService(TvPackageCartStoreInterface, TvPackageApi, $q) {

    var store = new TvPackageCartStoreInterface('UserAccount');

    store.canWrite = false;
    store.getItem = function (key) {
        //todo get the data from the API
        return $q.when(key);
    };

    store.setItem = function () {
        return $q.reject('TvPackageUserAccountStoreService is read only: cannot call setItem');
    };

    return store;
});